var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormButton',_vm._g(_vm._b({staticClass:"game-hud-button",attrs:{"transparent":""}},'FormButton',_vm.$attrs,false),Object.assign({}, _vm.$listeners)),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }